export default __webpack_public_path__ + "static/media/bubble-chart.f713591f.png";